import { render, staticRenderFns } from "./Electricities.vue?vue&type=template&id=016e83ab&"
import script from "./Electricities.vue?vue&type=script&lang=js&"
export * from "./Electricities.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports